module.exports = __webpack_public_path__ + "img/xtb.bef158eb.png";